import React from 'react';
import { ChevronUp, ChevronDown, LucideIcon } from 'lucide-react';
import { SortDirection } from '../../utils/sorting';

interface SortButtonProps {
  label: string;
  icon: LucideIcon;
  active: boolean;
  direction: SortDirection | null;
  onClick: () => void;
}

const SortButton = ({ label, icon: Icon, active, direction, onClick }: SortButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`group inline-flex items-center gap-2 ${
        active ? 'text-blue-600' : 'text-gray-500'
      }`}
    >
      <Icon className="w-4 h-4" />
      <span className="text-xs font-medium uppercase">{label}</span>
      <div className="flex flex-col">
        <ChevronUp 
          className={`w-3 h-3 ${
            active && direction === 'asc' 
              ? 'text-blue-600' 
              : 'text-gray-400 group-hover:text-gray-600'
          }`} 
        />
        <ChevronDown 
          className={`w-3 h-3 -mt-1 ${
            active && direction === 'desc' 
              ? 'text-blue-600' 
              : 'text-gray-400 group-hover:text-gray-600'
          }`} 
        />
      </div>
    </button>
  );
};

export default SortButton;